import { useMemo } from "react";
import { DataTable } from "@/components/molecules";
import { useProfile } from "@/hooks";
import { DepositsHistoryItem } from "@/redux/slices/payment/types";
import { clsx } from "@/utils";
import { generateBankDetailsDepositsHistoryColumns, generateBankDetailsDepositsHistoryData } from "../helpers";

export interface BankDetailsDepositsHistoryTableProps extends React.HTMLAttributes<HTMLDivElement> {
  items: DepositsHistoryItem[];
}

export const BankDetailsDepositsHistoryTable = ({ items, className, ...props }: BankDetailsDepositsHistoryTableProps) => {
  const { dateFormat, timeFormat } = useProfile();

  const data = generateBankDetailsDepositsHistoryData(items, dateFormat, timeFormat);
  const columns = useMemo(() => generateBankDetailsDepositsHistoryColumns(), []);

  return (
    <div className={clsx("relative flex", className)}>
      <DataTable className="w-full overflow-x-auto [&_table]:table-auto" columns={columns} data={data} {...props} />
    </div>
  );
};
